import styled from 'styled-components';

export default styled.div`
  width: 50%;
`;
